/**
 * Sub-sections of "Ustawienia Platformy" (platform operator only). Each one is a child route of
 * `platform-settings`, a tab on that page and a link in the sidebar section of the same name.
 */
export interface IPlatformSettingsSection {
  label: string;
  icon: string;
  path: string;
}

export const platformSettingsSections: IPlatformSettingsSection[] = [
  { label: 'Integracje', icon: 'pi pi-link', path: 'integrations' },
];
